import { RootState } from '../../rootReducer'

export const selectedTrainingWorkoutType = (state: RootState) => state.trainingWorkout.trainingWorkoutType
export const selectedTrainingWorkoutData = (state: RootState) => state.trainingWorkout.dataResult
export const selectedReloadTrainingWorkoutData = (state: RootState) => state.trainingWorkout.reload

export const modalCombineIsVisible = (state: RootState) => state.trainingWorkout.modalCombineIsVisible
export const modalCombineData = (state: RootState) => state.trainingWorkout.modalCombineData

export const modalAddTrainingWorkoutIsVisible = (state: RootState) => state.trainingWorkout.modalAddTrainingWorkoutIsVisible
export const modalAddTrainingWorkoutData = (state: RootState) => state.trainingWorkout.modalAddTrainingWorkoutData
export const seletectedTrainingWorkoutDataSelector = (state: RootState) => state.trainingWorkout.seletectedTrainingWorkoutData
